import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

const [w,d,mq] = [window,document,window.matchMedia('(max-width: 901px)')];

class scrollevent {
  constructor() {
    gsap.registerPlugin( ScrollTrigger );
    this.init();
  }
  init() {
    this.feature();
    this.intro();
  }

  intro () {
    let mainvideo = d.querySelector('.aboutus-header__video');
    let mainLead = d.querySelector('.aboutus-header__lead');
    let timeObserve = () => {
      if( mainvideo.currentTime <= 1 ){
        mainvideo.addEventListener('timeupdate', addClass );
        mainvideo.addEventListener('timeupdate', removeClass );
      }
    }
    let removeClass = () => {
      if( mainvideo.currentTime >= 0 ){
        mainLead.classList.remove('hidden');
        mainvideo.removeEventListener("timeupdate", removeClass, false);
      }
    }
    let addClass = () => {
      if( mainvideo.currentTime >= 2 ){
        mainLead.classList.add('hidden');
        mainvideo.removeEventListener("timeupdate", addClass, false);
      }
    };
    mainvideo.addEventListener('timeupdate', timeObserve );
  }
  feature () {
    gsap.fromTo('.is-feature02 .aboutus-feature__head-img img', {
      y: -150
    },{
      y: 50,
      scrollTrigger: {
        trigger: '.aboutus-feature.is-feature02',//アニメーションが始まるトリガーとなる要素
        start: 'top bottom', //アニメーションが始まる位置を指定
        end: 'bottom top',
        scrub: true,
        // markers: true,
      }
    });
  }
}

export default function ABOUTUS () {
  d.addEventListener('DOMContentLoaded', () => new scrollevent );
}